import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '../../../../../components/Button';
import { AuthContext } from '../../../../../contexts/AuthContext';
import {
  Modules,
  AuthRoutes,
  RouteParamsTypes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../../../../../enums';
import { hasResourseAccess } from '../../../../../utils/methods';

interface HeaderProps {
  id?: string;
  view: boolean;
  edit: boolean;
}

const Header: React.FC<HeaderProps> = ({ id, view, edit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.ProductDivisions]: [PermissionActionsEnum.Add] }],
  });
  const hasEditAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.ProductDivisions]: [PermissionActionsEnum.Update] }],
  });
  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.ProductDivisions]: [PermissionActionsEnum.View] }],
  });

  const handleGoToListClick = () => {
    navigate(Modules.products + AuthRoutes.productDivisions);
  };

  const handleEditButtonClick = () => {
    navigate(`${Modules.products}${AuthRoutes.productDivisions}${RouteParamsTypes.edit}/${id}`);
  };

  const handleAddNewClick = () => {
    navigate(Modules.products + AuthRoutes.productDivisions + RouteParamsTypes.add);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('productDivisions.addEdit.pageTexts.header.title')}</h4>
        <p className="mb-0">{t('productDivisions.addEdit.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        <div>
          {hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light me-3"
              onClick={handleGoToListClick}
              text={t('productDivisions.addEdit.pageTexts.header.goToList')}
            />
          )}

          {edit && hasAddAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t('productDivisions.addEdit.pageTexts.header.addNew')}
              onClick={handleAddNewClick}
            />
          )}

          {view && hasEditAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light mt-xs-3"
              text={t('productDivisions.addEdit.pageTexts.header.editBtn')}
              onClick={handleEditButtonClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
